import{createContext}from"react";var AppContext=createContext({});export default AppContext;